import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import { type VendorArticleFormSchema, vendorArticleFormSchema } from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { VendorArticleForm } from "@/forms/vendor-article-form";
import { client } from "@/hono";

/** Props Interface */
interface AddVendorArticleModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
	articleId: string;
}

export function AddVendorArticleModal({
	onClose,
	isOpen,
	articleId,
	onComplete,
}: AddVendorArticleModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(vendorArticleFormSchema),
	});

	/** Functions */
	async function handleOnSubmit(json: VendorArticleFormSchema) {
		const response = await client.stock.articles[":articleId"]["vendor-articles"].$post({
			json,
			param: { articleId },
		});
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.add_vendor_article")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<VendorArticleForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
